import { shallowEqual, useSelector } from 'react-redux';

import type { RootState } from '../../../../../../../store';
import type { InsuranceType } from '../../../../../../../utils/types';
import type { InsuranceExtractionEntry, InsuranceExtractionMap } from './types';

export function useInsuranceCardExtractionEntry(
  insuranceType: InsuranceType,
): InsuranceExtractionEntry | null {
  return useSelector(
    (state: RootState) => state.onboardingQuestionnaire.insuranceExtraction[insuranceType],
  );
}

export function useInsuranceExtractionMap(): InsuranceExtractionMap {
  return useSelector(
    (state: RootState) => state.onboardingQuestionnaire.insuranceExtraction,
    shallowEqual,
  );
}
